import React, { useState, useEffect, useContext } from 'react';
import '../../css/leaderBoard.css';
import { fetchWithDefaults } from '../../config/fetchDefault';
import BoardSlot from './boardSlot';
import DateSelector from './dateSelector';
import {setOpenLeaderBoard} from '../../features/topBarSlice';
import image from '../../assets/icons/loading-loader.gif';
import { useDispatch, useSelector } from 'react-redux';
import { AgentContext } from '../../context/AgentContext';
import BrandedIconButton from '../../utilities/inputComponents/BrandedIconButton';
import { brandedButtonTypes } from '../../utilities/inputComponents/BrandedButton';
import XClose from '../../svgIcon/XClose';

function LeaderBoard({}) {
    const dispatch=useDispatch();
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const boardState=useSelector((state) => state.topBar.leaderBoard);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [leaderBoard, setLeaderBoard] = useState(false);
    const [appointment, setAppointment] = useState(false);
    const [contact, setContact] = useState(false);
    const [dial, setDial] = useState(false);
    const [activeButton, setActiveButton] = useState('appointments');
    const [open, setOpen] = useState(false);
    const [leaderBoardLoading, setLeaderBoardLoading] = useState(true);

    const handleStartDateChange = (date) => {
        setSelectedStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setSelectedEndDate(date);
    };
    const getLeaderBoard = async () => {

        setLeaderBoardLoading(false);
        try {
            const response = await fetchWithDefaults(`/leaderBoard/get?start=${selectedStartDate}&end=${selectedEndDate}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');

            }
            const jsonData = await response.json();
            setLeaderBoardLoading(true);
            setLeaderBoard(jsonData);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleClose=()=>{
       dispatch(setOpenLeaderBoard(false));
    }
    const handleActive=(name)=>{
        setActiveButton(name);
    }
    useEffect(() => {
        if(leaderBoard){
            setAppointment(leaderBoard[0].appointment);
            setContact(leaderBoard[1].contact);
            setDial(leaderBoard[2].call);
         //   setLoading(false);
        }
    }, [leaderBoard]);
    useEffect(() => {
        if(selectedStartDate){
            getLeaderBoard();
        }
    }, [selectedStartDate]);

    const {isB2B} = useContext(AgentContext)
    return (
        <>
                <div className={`leaderBoardWrapper ${boardState ? 'openedLeaderBoard': ''}`}>
                    {!leaderBoardLoading && (
                        <div className="smallLoadingWrapper">
                            <div className="innerSmallLoadingWrapper">
                                <img src={image} alt="Loading Gif" style={{width: '100%'}} />
                            </div>
                        </div>
                    )}
                    <div style={{zIndex: '2', position: 'absolute', width: 48, height: 48, right: 10, top: 5 }}>
                        <BrandedIconButton clickHandler={_ => handleClose()} buttonType={brandedButtonTypes.TERTIARY} >
                            <XClose />
                        </BrandedIconButton>
                    </div>
                    <div className="leaderBoardHeader">
                        <div className="leaderBoardTitle">Leader Boards</div>
                        <div className="leaderTypeWrapper">
                            <div className={`leaderType ${activeButton==='appointments' ? 'activeButton' : ''}`} onClick={()=>handleActive('appointments')}>Appointments</div>
                            <div className={`leaderType ${activeButton==='contacts' ? 'activeButton' : ''}`} onClick={()=>handleActive('contacts')}>Contacts</div>
                            <div className={`leaderType ${activeButton==='dials' ? 'activeButton' : ''}`} onClick={()=>handleActive('dials')}>Dials</div>
                        </div>
                    </div>
                    <div className="leaderBoardContent">
                        {boardState && (
                            <DateSelector onStartDateChange={handleStartDateChange} onEndDateChange={handleEndDateChange} />
                        )}
                        <div className={`largeLeaderWrapper ${activeButton==='appointments' ? 'display' : ''}`}>
                            <div className="boardTitle">Appointments</div>
                            <div className={`${isB2B ? 'b2b ': ''}headerNames`}>
                                <div className="headerName name1">Place</div>
                                <div className="headerName name2">Agent</div>
                                <div className="headerName name3">Appointments</div>
                            </div>
                            {appointment && appointment.map((agent, index) => (
                                <BoardSlot data={agent} key={`appointmentBoard${index}`} place={index}/>
                            ))}
                        </div>

                        <div className={`largeLeaderWrapper ${activeButton==='contacts' ? 'display' : ''}`}>
                            <div className="boardTitle">Contacts</div>
                            <div className={`${isB2B ? 'b2b ': ''}headerNames`}>
                                <div className="headerName name1">Place</div>
                                <div className="headerName name2">Agent</div>
                                <div className="headerName name3">Contacts</div>
                            </div>
                            {contact && contact.map((agent, index) => (
                                <BoardSlot data={agent} key={`contactBoard${index}`} place={index}/>
                            ))}
                        </div>

                        <div className={`largeLeaderWrapper ${activeButton==='dials' ? 'display' : ''}`}>
                            <div className="boardTitle">Dials</div>
                            <div className={`${isB2B ? 'b2b ': ''}headerNames`}>
                                <div className="headerName name1">Place</div>
                                <div className="headerName name2">Agent</div>
                                <div className="headerName name3">Dials</div>
                            </div>
                            {dial && dial.map((agent, index) => (
                                <BoardSlot data={agent} key={`dialBoard${index}`} place={index}/>
                            ))}
                        </div>
                    </div>
                </div>

        </>
    );
}

export default LeaderBoard;
